<template>
    <div class="card" v-if="horizontalbar.visibleFlag === true" style="height: 101%">
        <div class="card-header d-flex justify-content-between">
            <div class="">{{horizontalbar.vizTitle}}</div>
            
                <select v-model="salesmanData" class="c-s">
                    <option v-for="l1 in filterSalesman" v-bind:key="l1">{{l1}}</option>
                </select>
            <a v-on:click="commentBox(horizontalbar)" class="txt-color-white right-padding-50">
                <i class="fa fa-lg fa-comments"></i>
            </a>
        </div>
        <div class="card-body">
            <div class="mb-3" style="padding-top: 25px">
                <div id="checkboxes">
                    <label class="">
                        <input id="checkbox" type="checkbox" class="continent" checked="">
                        Known Death Toll Only
                    </label>
                </div>
                <div class="since-group mb-2" data-toggle="buttons-radio">
                    <label class="">Since</label>
                    <input class="" type="text" id="from" value="2015" />

                    <label class="ml-5">Until</label>
                    <input class="" type="text" id="to" value="2020">
                </div>
                <div class="sort-group" data-toggle="buttons-radio">
                    <button type="button" class="since btn btn-secondary mr-1" value="basedOnInput">
                        Show
                    </button>
                    <button type="button" class="since btn btn-secondary ml-1" value="all">
                        Show All
                    </button>
                    <button type="button" class="sort btn btn-secondary ml-2" value="sortTotalSpan">
                        Sort by Total Span
                    </button>
                    <button type="button" class="sort btn btn-secondary ml-2" value="sortStartYear">
                        Sort by Start Year
                    </button>
                    <button type="button" class="sort btn btn-secondary ml-2" value="sortTotalDeathToll">
                        Sort by Total Death Toll
                    </button>
                </div>
            </div>
            <div :id="id" ref="r1c1"></div>
        </div>
        <b-modal ref="comment-box" @ok="postAnnotation()" :title="annotationTitle">
            <b-form-group label="Comment">
                <textarea rows="3" cols="40" v-model="cmnt"
                          placeholder="Write a comment..."></textarea>
            </b-form-group>
        </b-modal>
    </div>
</template>
<script>
import {FwVizChartInfo} from "../models";
import axios from "axios";

export default {
        name: 'Horizontalbar',
        props: {
            horizontalbar: Object
        },
        data: () => ({
            salesmanData:[],
            filterSalesman:'',
            showModal: false,
            cmnt: "",
            annotations: [],
            searching: false,
            annotationTitle: '',
            id: `VIZ-${new Date().getTime()}`
        }),
        methods: {
            loadSalesman: function () {
                axios.get('/api/salesman-list/')
                .then(res => {
                    this.salesmanData = res.data
                    this.filterSalesman = Array.from(new Set(this.salesmanData.map(c => c.dim1).filter(x => x != null)))
                    console.log("Salesman data:", this.filterSalesman)  
                }, err => {
                    console.log('Error in fetching record', err)
                })
            },

            commentBox: function (what) {
                console.log(`ENTERED into the commentBox function(${what.menuName}, ${what.screenName})`)
                this.cmt = '';
                this.pg = what.menuName;
                this.section = what.screenTitle;
                this.annotationHeader = "User Annotations";
                this.annotationTitle = this.annotationHeader + '->' + this.pg + '->' + this.section
                this.$refs['comment-box'].show()
            },

            postAnnotation: function () {
                const url = '/api/annotation';
                const data = {
                    userId: 1,
                    userName: "Admin",
                    page: this.pg,
                    section: this.section,
                    comment: this.cmnt
                };
                axios.post(url, data)
                    .then(() => {
                       this.$store.dispatch('loadAnnotations')
                    }, e => {
                      //  this.$commonFn.auditLog(this.horizontalbar.menuSyspk,menu, subMenu, "", "POST", e)
                        console.error('error in updating annotations', e)
                    })
                let menu = this.pg;
                let subMenu = this.section;
                console.log("the menus and submenus for Audit log is", menu, subMenu)

              //  this.$commonFn.auditLog(this.horizontalbar.menuSyspk,menu, subMenu, "", "POST", "Success")
            },

        },
        created() {
            this.loadSalesman()
            this.$store.dispatch("loadState").then(() => {
                let allVizType = this.$store.state.vizType
                let v = this.horizontalbar
                let margin = {
                    top: v.pmTop,
                    right: v.pmRight,
                    bottom: v.pmBottom,
                    left: v.pmLeft
                }

                let vizId = v.viztypeId
                let filter = allVizType.filter(t => t.viztypeId === vizId)[0];
                let vizname = filter.viztypeClassName
                console.log("vizName in vue",vizname)
                let vizFunction = filter.viztypeFunctionName

                let divId = this.$refs.r1c1

                let vizunit = v.positionLogical

                let getChartInfo = (vizunit) => {
                    let f = v
                    if (f.length === 0) return new FwVizChartInfo(vizunit, margin, {}, false, [])
                    return new FwVizChartInfo(vizunit, margin, f, v.visibleFlag, f)
                }

                this.position = getChartInfo(vizunit)

                let chartData = this.position
                console.log("The chart data is" , chartData, vizname, divId)

                setTimeout(() => {
                    this.$commonFn.renderChart(vizname, chartData, divId, vizFunction);
                }, 300)

            })

        }
    }
</script>
<style>
    .cobackground {
        fill: #eee;
    }

    text.active {
        fill: red;
    }
    .c-s {
        margin-top: -7px;
        margin-left: 500px;
        height:30px
    }
    .tick line {
        opacity: 0.5;
        stroke-dasharray: 5, 5;
    }
</style>